module.exports = __webpack_public_path__ + "static/img/cert5.b443117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert5.png
// module id = kyDZ
// module chunks = 51